import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { Sector } from '../../../types/modules/admin/sector.type'
import UpdateSectorForm from './UpdateSectorForm'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    sector:Sector
}

function SectorItem({sector}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = sector.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = sector.languages.find(s=>s.languageCode==="ar")?.name ||"";


  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(sector.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {arName}
        </td>


        <PermissionGate permissions={[PermissionsKey.UpdateSector]}>
            <td className="p-3 min-w-[200px] text-Black font-normal">
                <button onClick={()=>setIsOpen(p=>!p)}>
                    <Edit/>
                </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateSectorForm
        id={sector.id}
        defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default SectorItem